function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSb7Outline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1128.88 1305.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2",
    d: "m457.7,19.6c247.81,0,448.7,282.46,448.7,630.9s-200.89,630.9-448.7,630.9S9,998.94,9,650.5,209.89,19.6,457.7,19.6Zm2.9-15.6c252.17,0,456.6,290.39,456.6,648.6s-204.43,648.6-456.6,648.6S4,1010.81,4,652.6,208.43,4,460.6,4Zm111.5,19.5h104.7s57.9,1.9,82,8.7c0,0,256.5,38.6,349.1,420.4l-47.3,136.9,18,13,7.3,18.6s18.7,23.7-5.9,59.7c0,0-9.8,13.9-22.9,20l62.6,43.4s6.6,2.5,4.9,10.6c0,0-53.6,482.2-416.5,519.6h-116.4m515.1-826.1h-212.7m213.3,5.8l-212.1-.7m17.4,291.1l207.1-.3m-208.1,9.9l213,.7m-46-152.3l-14.1-10.2-12.5-8h-42.5l-39.3,48.8,4.9,49.4,24.8,16.7s10,3.8,22.9,3.4m23.81-47.49c10.03-12.7,24.6-17.91,32.53-11.64s6.22,21.64-3.81,34.34-24.6,17.91-32.53,11.64-6.22-21.64,3.81-34.34Zm-28.38-19c16.4-23.71,43.72-33.23,61.02-21.27s18.05,40.89,1.65,64.6-43.72,33.23-61.02,21.27-18.05-40.89-1.65-64.6Zm55.48,4.99c5.1,7.3,2.7,20.6-6.2,31.8-8,10.1-18.9,15.5-27,14.1m-439.3-96.4v3.4c0,7.8-4.4,14.2-9.9,14.2h-269.8v-31.7h269.8c5.5,0,9.9,6.3,9.9,14.1h0Zm-79.1,63.5v3.4c0,7.8-4.4,14.2-9.9,14.2h-190.7v-31.8h190.7c5.4.1,9.9,6.4,9.9,14.2h0Zm79.1,63.5v3.4c0,7.8-4.4,14.2-9.9,14.2h-269.8v-31.7h269.8c5.5,0,9.9,6.3,9.9,14.1h0Zm315.4-32.9h61.5m-61.5-11.6h57.4m104.6-70.6s-12.3,5.1-43.8,0l-25.4-18.1m25.3,18.1s-10.5,31.3-39.8,48l-24.9-17.4m24.9,17.4s11.6,25.8,4.8,48.7",
    style: {
      fill: "none",
      stroke: "#002dcc",
      strokeMiterlimit: 10,
      strokeWidth: 10
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSb7Outline);
export default __webpack_public_path__ + "static/media/SB7Outline.00f3842de946c85c957b369702635ccd.svg";
export { ForwardRef as ReactComponent };